import * as moment from 'moment';

moment.locale('pt-br');
